export default function convertOffsetToPage(offset, limit) {
  return Math.floor(offset / limit);
}
